<textarea
  class="form-control shadow-none"
  [name]="name"
  [formControlName]="formControlName"
  placeholder="{{ placeholder | msg | async }}"
  rows="4"
  cols="50"
  (change)="onChange($event)"
></textarea>
